import { render, staticRenderFns } from "./Quarantine.vue?vue&type=template&id=e4068a4e&scoped=true"
import script from "./Quarantine.vue?vue&type=script&lang=js"
export * from "./Quarantine.vue?vue&type=script&lang=js"
import style0 from "./Quarantine.vue?vue&type=style&index=0&id=e4068a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4068a4e",
  null
  
)

export default component.exports